import { forwardRef } from 'react';
import StyledCheckbox from './style';

const MultiStyledCheckbox = forwardRef(({children, label, borderColor, borderRadius, disabled, status, typeDisable, ...props}, ref) => {
  let icon = ''

  switch (status) {
  case 'OK':
    icon = <svg width="20px" height="21px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="20" stroke="black" strokeWidth="4"/></svg>
    break;
  case 'PARTIALOK':
    icon = <svg width="20px" height="21px"  viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><polygon points="3,18 10,3 18,18" stroke="black" strokeWidth="1.5" fill="none" /></svg>
    break;
  case 'NOTOK':
    icon = <svg width="20px" height="21px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5L13.5 13.5M1.5 13.5L13.5 1.5" stroke="black"/></svg>
    break;
  case 'DISABLED':
    icon = <svg width="20px" height="21px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 13.5L13.5 1.5" stroke="black"/></svg>
    break;
  case 'BLANK':
    icon = ''
    break;
  case 'LEAVE':
    icon = (
      <span style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        fontSize: '14px',
        fontWeight: 'bold',
      }}>
        休
      </span>
    );
    break;
  default:
    icon = '';
    if (disabled && typeDisable === 'DateTime') {
      icon = <svg width="20px" height="21px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 13.5L13.5 1.5" stroke="black"/> </svg>
    }
    if (disabled && typeDisable === 'NotHeadquarter' ) {
      icon = '';
    }
  }

  return (
    <StyledCheckbox borderRadius={borderRadius} borderColor={`--${borderColor}-color`} ref={ref}>
      <input type="checkbox" disabled={disabled} {...props} />
      <span className={`checkmark ${disabled ? 'disabled' : ''}`}>{icon}</span>
      <p>{label}</p>
    </StyledCheckbox>
  )
})

MultiStyledCheckbox.defaultProps = {
  borderColor: 'border',
  borderRadius: 'none',
  disabled: false,
  status: null
}

export default MultiStyledCheckbox;
